import { SupportedChainId } from './chain'

export const ZOOM_ADDRESSES = {
    [SupportedChainId.MAINNET]: "0x7cdF091AF6a9ED75E3192500d3e5BB0f63e22Dea",
    [SupportedChainId.RINKEBY]: "0x491592F30D9a3d1887F486eA2A3c72ad82fAcF4D",
    [SupportedChainId.GOERLI]: "0xebC7d793d062371C11cB802e7D49eEAA0c30EB06"
}

export const ENS_NFT_ADDRESSES = {
    [SupportedChainId.MAINNET]: "0x360e63c77ae3bbad546e85d2f7ba7e6c98a2abfe",
    [SupportedChainId.RINKEBY]: "0xb093c0c8ce0d1107532fc0a078143c6d0e5c95f0",
    [SupportedChainId.GOERLI]: "0x03da6a50cf154c64a16b3bffb437727420048dfc"
}